import type { JobSuggestion } from '../shared/desktop-api';

/** Native classification owns business choices. Missing metadata must not ask
 * an operator to approve an internal reading hypothesis. */
export const isJobAdjustment = (
  suggestion: Pick<JobSuggestion, 'requiresOperatorDecision'>,
): boolean => suggestion.requiresOperatorDecision === true;
